module.exports = __webpack_public_path__ + "static/img/metting.1e4b586.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/metting.jpg
// module id = Udu4
// module chunks = 1